<template>
    <div>
        <b-row>
            <b-col md="6" xs="12">
                <div class="card card-inverse card-info">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="m-r-20 align-self-center">
                                <h3 class="card-title">Sent Enrollment</h3>
                                <h6 class="card-subtitle">January 2018 <a href="#details" @click="showDetails = true">View Details</a></h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 align-self-center">
                                <h1 class="font-light text-white">464</h1>
                            </div>
                            <div class="col-8 p-t-10 p-b-20 text-right">
                                <h1 class="text-white"><i class="fa fa-mail-forward"></i></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col md="6" xs="12">
                <div class="card card-inverse card-primary">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="m-r-20 align-self-center">
                                <h3 class="card-title">Sent Information Packet</h3>
                                <h6 class="card-subtitle">January 2018 <a href="#details" @click="showDetails = true">View Details</a></h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 align-self-center">
                                <h1 class="font-light text-white">41</h1>
                            </div>
                            <div class="col-8 p-t-10 p-b-20 text-right">
                                <h1 class="text-white"><i class="fa fa-envelope"></i></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" xs="12">
                <div class="card card-inverse card-success">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="m-r-20 align-self-center">
                                <h3 class="card-title">Enrolled</h3>
                                <h6 class="card-subtitle">January 2018 <a href="#details" @click="showDetails = true">View Details</a></h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 align-self-center">
                                <h1 class="font-light text-white">1221</h1>
                            </div>
                            <div class="col-8 p-t-10 p-b-20 text-right">
                                <h1 class="text-white"><i class="fa fa-check-square-o"></i></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col md="6" xs="12">
                <div class="card card-inverse card-danger">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="m-r-20 align-self-center">
                                <h3 class="card-title">Declined</h3>
                                <h6 class="card-subtitle">January 2018 <a href="#details" @click="showDetails = true">View Details</a></h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 align-self-center">
                                <h1 class="font-light text-white">46</h1>
                            </div>
                            <div class="col-8 p-t-10 p-b-20 text-right">
                                <h1 class="text-white"><i class="fa fa-times-circle-o"></i></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-show="showDetails">
            <b-col>
                <a name="details"></a>
                <client-list :clients="clients"></client-list>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            return {
                showDetails: false,
                clients: [],
            }
        },

        mounted() {
            axios.get('/business/clients')
                .then(response => {
                    this.clients = response.data;
                });
        },

        methods: {},
    }
</script>

<style>
    .card-inverse a {
        color: #fff;
        text-decoration: underline;
    }
</style>